import { ErrorBoundary as SentryErrorBoundary } from "@sentry/react"
import React from "react"

const ErrorBoundary: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  return (
    <SentryErrorBoundary
      fallback={({ error, componentStack }) => (
        <div className="react-error flex-1 space-y-2 rounded-md border border-yellow-400 bg-yellow-50 p-2">
          <h2 className="mx-auto mb-0 text-center text-xl font-medium text-gray-500">Unexpected error!</h2>
          <div className="mx-auto h-1 w-[60px] bg-error-light text-black" />
          <details className="mx-auto max-w-5xl whitespace-pre-wrap text-base font-normal dark:text-black">
            <summary className="text-center text-sm text-gray-500">Details</summary>
            {(error as Error).toString()}
            <br />
            {componentStack}
          </details>
        </div>
      )}
    >
      {children}
    </SentryErrorBoundary>
  )
}

export default ErrorBoundary
